export interface DotBackgroundOverlayComponentState {
  opacityType: 'solid' | 'radial';
  hexOpacity: string;
  hexColor: string;
  customClasses: string | string[] | Set<string> | { [k: string]: any };
  isMobile: boolean;
}
export interface DotBackgroundOverlayComponentViewModel {
  isMobile: boolean;
  isRadial: boolean;
  customClasses: string | string[] | Set<string> | { [k: string]: any };
  bgStyles: { [k: string]: string };
}

export const dotBackgroundOverlayComponentInitialState: DotBackgroundOverlayComponentState =
  {
    hexOpacity: '',
    opacityType: 'solid',
    isMobile: true,
    hexColor: undefined,
    customClasses: undefined,
  };
